import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import OurTeam from './pages/OurTeam';
import PracticeAreasLanding from './pages/PracticeAreasLanding';
import AutoAccidents from './pages/practice-areas/AutoAccidents';
import CatastrophicInjury from './pages/practice-areas/CatastrophicInjury';
import PremisesLiability from './pages/practice-areas/PremisesLiability';
import TruckingAccidents from './pages/practice-areas/TruckingAccidents';
import WorkersCompensation from './pages/practice-areas/WorkersCompensation';
import WrongfulDeath from './pages/practice-areas/WrongfulDeath';
import CaseResults from './pages/CaseResults';
import Testimonials from './pages/Testimonials';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import CarAccident from './pages/CarAccident';
import CarAccidentGetStarted from './pages/CarAccidentGetStarted';
import CarAccidentThankYou from './pages/CarAccidentThankYou';
import ChatWidget from './components/ChatWidget';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function MainSite() {
  return (
    <>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/practice-areas" element={<PracticeAreasLanding />} />
          <Route path="/practice-areas/auto-accidents" element={<AutoAccidents />} />
          <Route path="/practice-areas/catastrophic-injury" element={<CatastrophicInjury />} />
          <Route path="/practice-areas/premises-liability" element={<PremisesLiability />} />
          <Route path="/practice-areas/trucking-accidents" element={<TruckingAccidents />} />
          <Route path="/practice-areas/workers-compensation" element={<WorkersCompensation />} />
          <Route path="/practice-areas/wrongful-death" element={<WrongfulDeath />} />
          <Route path="/case-results" element={<CaseResults />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<Legal />} />
        </Routes>
      </Layout>
      <ChatWidget />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/car-accident" element={<CarAccident />} />
        <Route path="/get-started" element={<CarAccidentGetStarted />} />
        <Route path="/car-accident/thank-you" element={<CarAccidentThankYou />} />
        <Route path="/*" element={<MainSite />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;